import React from "react";
import Nav from "./../components/Nav/Nav";

function NavPage() {
  return <Nav />;
}

export default NavPage;
